module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('h1', {
    staticClass: "f2 lh-copy pt3"
  }, [_vm._v(_vm._s(_vm.$t('planssettings.editcoverage1', {
    editcoverage1: 'Which plan would you like?'
  })))]), _vm._v(" "), _c('div', {
    staticClass: "tc mt7-ns"
  }, [_c('a', {
    staticClass: "gray",
    attrs: {
      "href": "mailto:billing@getakko.com",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(_vm.$t('planssettings.editcoverage2', {
    editcoverage2: 'Dale Clic Aquí para Solicitar una Actualización o Cambio a tu Plan'
  })))]), _vm._v(" " + _vm._s(_vm.$t('planssettings.editcoverage3', {
    editcoverage3: 'ó envía un correo a billing@getakko.com'
  })) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e272d4e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditCoverage.vue
// module id = 1522
// module chunks = 0